export enum OperationRuleAlertNotificationType {
  "BEFORE" = "before",
  "AFTER" = "after",
}
